import { Box, useTheme } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { TOP_NAVIGATION_HEIGHT } from '../../constants/style';
import ChatDrawer from '../../features/agentChat/ChatDrawer';
import { useAuth } from '../../hooks/useAuth';
import { useConfig } from '../../hooks/useConfig';
import DebugView from './DebugView';
import ExtraPanel from './ExtraPanel';
import PageEffects from './PageEffects';
import SubNav from './SubNav';

function UPLayout() {
  const { user } = useAuth();
  const { useUPViews, setUseUPViews } = useConfig();
  const theme = useTheme();

  // eslint-disable-next-line @typescript-eslint/dot-notation
  const mainNavHeight = theme?.mixins?.toolbar?.['@media (min-width:600px)']?.['minHeight'] || TOP_NAVIGATION_HEIGHT;

  React.useEffect(() => {
    if (!useUPViews) {
      setUseUPViews(true);
    }
  }, [useUPViews, setUseUPViews]);

  if (!user) {
    return (
      <>
        <ExtraPanel />
        <DebugView />
        <Outlet />
      </>
    );
  }
  return (
    <Box
      sx={{
        background: '#F9F9F9',
        height: import.meta.env.VITE_IS_FEDERATED ? `calc(100vh - ${mainNavHeight}px )` : '100vh',
        paddingLeft: import.meta.env.VITE_IS_FEDERATED ? '10px' : '',
      }}
    >
      <PageEffects />
      <ExtraPanel />
      <DebugView />
      <SubNav />
      <ChatDrawer />
      <Box
        sx={{
          // The agent chat drawer is non-modal: from lg up the routed content gives up
          // its width instead of being covered. The nav above stays full-bleed.
          // ChatDrawer owns the custom property.
          paddingRight: { xs: 0, lg: 'var(--ach-chat-inset, 0px)' },
          transition: 'padding-right 225ms cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

function UPWrappedLayout() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <UPLayout />
    </LocalizationProvider>
  );
}

export default UPWrappedLayout;
